const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  translang: state => state.app.translang,
  referer: state => state.app.referer,
  preferer: state => state.app.preferer,
  remember: state => state.app.remember,
  username: state => state.app.username,
  device: state => state.app.device,
  uid: state => state.user.uid,
  uname: state => state.user.username,
  roles: state => state.user.roles,
  regionList: state => state.region.list,
  brandList: state => state.brand.list,
  indList: state => state.industry.list,
  currencyList: state => state.currency.list,
  languageList: state => state.language.list,
  languageFilter: state => state.language.filter,
  openCCType: state => state.language.opencc,
  brandField: state => state.brandField.map,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permErrs: state => state.perm.errs,
  perms: state => state.perm.perms
}
export default getters
